/**
 * Heading components
 *
 * Optional props:
 * size : string - font size (with unit)
 * primary : boolean - primary text color
 * light : boolean - light text color
 * normal : boolean - normal font weight
 * thin : boolean - thin font weight
 *
 * Examples for component:
 * <Title>Standard title</Title>
 * <Title size="14px" primary bold>Primary bold title with size of 14px</Title>
 *
 */

import styled from 'styled-components';
import { colors } from '../../variables';

const getFontWeight = props => {
	if (props.thin) return '300';
	if (props.normal) return '400';
	return '700';
};

const getColor = props => {
	if (props.primary) return colors.blue.bromma;
	if (props.light) return '#fff';
	return colors.grey.graphite;
};

export const Title = styled.h1`
	font-size: ${props => (props.size ? props.size : '32px')};
	font-weight: ${props => getFontWeight(props)};
	color: ${props => getColor(props)};
`;

export const Heading = styled.h2`
	font-size: ${props => (props.size ? props.size : '24px')};
	font-weight: ${props => getFontWeight(props)};
	color: ${props => getColor(props)};
`;

export const SubHeading = styled.h3`
	font-size: ${props => (props.size ? props.size : '18px')};
	font-weight: ${props => getFontWeight(props)};
	color: ${props => getColor(props)};
`;



// WEBPACK FOOTER //
// ./src/components/Common/Headings/Headings.js